import type { DmLastResolution } from '../../../../services/dmNotifications';
import { DmPatientMessagesPanel } from '../../../patient-files/actions/dm/DmPatientMessagesPanel';
import type { AiReplySource } from '../triage/aiTriageState';

interface MessagesThreadCardProps {
    patientId: string;
    unreviewedCount: number;
    lastResolution: DmLastResolution | null;
    aiReply?: AiReplySource;
}

export function MessagesThreadCard({
    patientId,
    unreviewedCount,
    lastResolution,
    aiReply
}: MessagesThreadCardProps) {
    return (
        <section
            aria-label="Messages"
            className="flex h-full min-h-0 flex-col overflow-hidden rounded-xl border border-gray-200 bg-white font-inter"
        >
            <DmPatientMessagesPanel
                patientId={patientId}
                unreviewedCount={unreviewedCount}
                lastResolution={lastResolution}
                aiReply={aiReply}
                embedded
            />
        </section>
    );
}
